import React from 'react';
import {Helmet} from "react-helmet-async";

import NewsletterSection from "../../components/NewsletterSection";



const Preise = () => {

    return (
        <>
            <Helmet>
                {/* Seiten-Titel */}
                <title>Unsere Preise - Cloudtal</title>

                {/* Meta-Informationen */}
                <meta
                    name="description"
                    content="Entdecken Sie unsere flexiblen und transparenten Preismodelle für PostgreSQL und Keycloak. DSGVO-konform und sicher in Deutschland gehostet."
                />
                <meta
                    name="keywords"
                    content="Preise, Cloud-Dienste, PostgreSQL, Keycloak, Open Source, DSGVO, Hosting, Cloudtal"
                />
                <meta name="author" content="Cloudtal Team" />

                {/* Open Graph für Social Media */}
                <meta property="og:title" content="Unsere Preise - Cloudtal" />
                <meta
                    property="og:description"
                    content="Erfahren Sie mehr über unsere flexiblen und transparenten Preismodelle für PostgreSQL und Keycloak. DSGVO-konform und sicher in Deutschland gehostet."
                />
                <meta property="og:type" content="website" />
                <meta property="og:url" content="https://www.cloudtal.de/pricing" />

                {/* Canonical URL */}
                <link rel="canonical" href="https://www.cloudtal.de/pricing" />
            </Helmet>
            <main className="flex-1">
                {/* Hero Section */}
                <section className="relative w-full min-h-screen bg-black text-white flex items-center justify-center overflow-hidden">
                    <div className="container px-4 md:px-6 text-center">
                        <h1 className="text-3xl font-bold tracking-tighter sm:text-4xl md:text-5xl lg:text-6xl text-white">
                            Unsere Preise
                        </h1>
                        <p className="mx-auto max-w-[700px] text-zinc-400 md:text-xl">
                            Flexible und transparente Preismodelle, die sich an die Bedürfnisse Ihres Unternehmens anpassen. Alle unsere Dienste sind vollständig in Deutschland gehostet und DSGVO-konform.
                        </p>
                    </div>
                </section>

                {/* Pricing Section */}
                <section className="relative w-full py-48 md:py-64 lg:py-80 bg-zinc-900">
                    <div className="container px-4 md:px-6">
                        <div className="flex flex-col items-center justify-center space-y-4 text-center">
                            <h2 className="text-3xl font-bold tracking-tighter sm:text-5xl text-white">Unsere Preise</h2>
                            <p className="max-w-[900px] text-zinc-400 md:text-xl lg:text-base xl:text-xl">
                                Unsere Preismodelle sind in Arbeit und folgen bald. Bleiben Sie gespannt auf transparente und faire Angebote!
                            </p>
                        </div>
                        <div className="mx-auto max-w-5xl py-12 grid grid-cols-1 md:grid-cols-3 gap-8">
                            {/* Pricing Cards */}
                            {["PostgreSQL", "Keycloak", "Weitere Produkte"].map((title, index) => (
                                <div key={index} className="flex flex-col h-full bg-zinc-800 p-6 rounded-lg shadow-md hover:shadow-lg hover:-translate-y-1 transition duration-300 text-center">
                                    <div className="w-full flex justify-center mb-4">
                                        {index === 0 ? (
                                            <svg xmlns="http://www.w3.org/2000/svg" className="lucide lucide-database h-12 w-12 text-green-500" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                                <ellipse cx="12" cy="5" rx="9" ry="3"></ellipse>
                                                <path d="M3 5V19A9 3 0 0 0 21 19V5"></path>
                                                <path d="M3 12A9 3 0 0 0 21 12"></path>
                                            </svg>
                                        ) : index === 1 ? (
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-key-round h-12 w-12 text-green-500 mb-2">
                                                <path d="M2.586 17.414A2 2 0 0 0 2 18.828V21a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-1a1 1 0 0 1 1-1h1a1 1 0 0 0 1-1v-1a1 1 0 0 1 1-1h.172a2 2 0 0 0 1.414-.586l.814-.814a6.5 6.5 0 1 0-4-4z"></path>
                                                <circle cx="16.5" cy="7.5" r=".5" fill="currentColor"></circle>
                                            </svg>
                                        ) : (
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-plus-circle h-12 w-12 text-green-500 mb-2">
                                                <circle cx="12" cy="12" r="10"></circle>
                                                <line x1="12" x2="12" y1="8" y2="16"></line>
                                                <line x1="8" x2="16" y1="12" y2="12"></line>
                                            </svg>
                                        )}
                                    </div>
                                    <h3 className="text-xl font-semibold text-white">{title}</h3>
                                    <p className="mt-4 text-zinc-400 flex-1">
                                        {index === 0 ? "Leistungsstarke Datenbanklösungen für Ihre Projekte." :
                                            index === 1 ? "Zentrale Authentifizierung und Sicherheitslösungen." :
                                                "Freuen Sie sich auf innovative Lösungen, die bald verfügbar sind."}
                                    </p>
                                    <p className="mt-6 text-2xl font-bold text-white">{index === 2 ? "Produkte folgen" : "Preise folgen"}</p>
                                    <button className="mt-6 w-full bg-green-500 text-white py-3 rounded-xl cursor-not-allowed">
                                        {index === 2 ? "Bleiben Sie informiert" : "Demnächst verfügbar"}
                                    </button>
                                </div>
                            ))}
                        </div>
                    </div>
                </section>


                {/* FAQ Section */}
                <section className="relative w-full py-48 md:py-64 lg:py-80 bg-black">
                    <div className="container px-4 md:px-6">
                        <div className="flex flex-col items-center justify-center space-y-4 text-center">
                            <h2 className="text-3xl font-bold tracking-tighter sm:text-5xl text-white">Häufig gestellte Fragen</h2>
                            <p className="max-w-[900px] text-zinc-400 md:text-xl lg:text-base xl:text-xl">
                                Antworten auf die häufigsten Fragen rund um unsere Preismodelle und Dienstleistungen.
                            </p>
                        </div>
                        <div className="mx-auto max-w-5xl py-12">
                            <div className="space-y-6">
                                {/* FAQ Item 1 */}
                                <div>
                                    <h3 className="text-xl font-semibold text-zinc-200">Wie kann ich den Plan wechseln?</h3>
                                    <p className="mt-2 text-zinc-400">
                                        Sie können jederzeit Ihren Plan über Ihr Dashboard aktualisieren oder downgraden. Bei Fragen steht Ihnen unser Support-Team gerne zur Verfügung.
                                    </p>
                                </div>
                                {/* FAQ Item 2 */}
                                <div>
                                    <h3 className="text-xl font-semibold text-zinc-200">Sind die Dienste DSGVO-konform?</h3>
                                    <p className="mt-2 text-zinc-400">
                                        Ja, alle unsere Dienste sind vollständig DSGVO-konform und werden sicher in Deutschland gehostet.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                {/* Newsletter Section */}
                <NewsletterSection
                    title="Exklusives Beta-Tester-Programm"
                    description="Testen Sie als einer der wenigen unsere Beta-Version und erleben Sie die neuesten Funktionen vor allen anderen. Die Teilnehmerzahl ist streng limitiert – sichern Sie sich jetzt Ihren Platz!"
                    placeholder="Ihre E-Mail-Adresse"
                    buttonText="Jetzt registrieren"
                    privacyText="Wir respektieren Ihre Privatsphäre. Abmeldung jederzeit möglich."
                    additionalClassName="bg-zinc-900 bg-bottom text-white"
                />
            </main>
        </>
    );
};

export default Preise;
